import React from 'react';
import { useNavigate } from 'react-router-dom';
import OppSectionsNavigation from './OppSectionsNavigation';
import OppSectionEditor from './OppSectionEditor';
import { AISuggestionPanel } from '../plans';
import { PREDEFINED_OPP_SECTIONS } from '../../constants/oportunidadesConstants';

const OppEditor = ({
  currentPlan,
  sections,
  activeSection,
  activeSectionId,
  answers,
  savingDraft,
  aiLoading,
  ai,
  aiError,
  guide,
  usageLimits,
  generatingReport,
  reportResult,
  onSectionChange,
  onChangeAnswer,
  onApplyOption,
  onSaveDraft,
  onSuggest,
  onGenerateReport,
  onShowGuide,
  onCloseGuide,
  onCloseAi,
}) => {
  const navigate = useNavigate();

  if (!currentPlan) {
    return <p>Selecciona o crea un plan para identificar oportunidades de mercado.</p>;
  }

  const hasAnySectionComplete = sections.some((section) =>
    section.questions?.some((q) => (answers[q.id] || '').trim().length > 0),
  );

  const isPredefined = activeSection
    ? PREDEFINED_OPP_SECTIONS.has(activeSection.section_title)
    : false;

  const handleViewReport = () => navigate(`/plans/opp/${currentPlan.slug}/result`);

  return (
    <div>
      <div className="plan-header">
        <div className="plan-header-left">
          <h1>{currentPlan.title}</h1>
          <span className="usage-badge">Mapa de oportunidades</span>
        </div>
        {reportResult && (
          <button className="view-action-plan-btn" onClick={handleViewReport}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7l-3 3-1.5-1.5"/>
            </svg>
            Ver mapa de oportunidades
          </button>
        )}
      </div>

      <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
        <OppSectionsNavigation
          sections={sections}
          activeSectionId={activeSectionId}
          answers={answers}
          generatingReport={generatingReport}
          hasReport={!!reportResult}
          hasAnySectionComplete={hasAnySectionComplete}
          onSectionChange={onSectionChange}
          onGenerateReport={onGenerateReport}
        />

        <div style={{ flex: 1, minWidth: 0 }}>
          <OppSectionEditor
            activeSection={activeSection}
            answers={answers}
            savingDraft={savingDraft}
            aiLoading={aiLoading}
            guide={guide}
            usageLimits={usageLimits}
            onChangeAnswer={onChangeAnswer}
            onApplyOption={onApplyOption}
            onSaveDraft={onSaveDraft}
            onSuggest={onSuggest}
            onShowGuide={onShowGuide}
            onCloseGuide={onCloseGuide}
          />

          <AISuggestionPanel
            aiData={ai}
            aiError={aiError}
            isPredefined={isPredefined}
            predefinedLabel="Recomendaciones estratégicas"
            onClose={onCloseAi}
          />
        </div>
      </div>
    </div>
  );
};

export default OppEditor;
